import gql from "graphql-tag";
import PropTypes from "prop-types";

export default {
  query: gql`
    query searchClients(
      $searchBy: SearchField!
      $search: String!
      $searchPersons: Boolean!
      $searchCompanies: Boolean!
      $rowFrom: Int
      $rowTo: Int
    ) {
      clients(
        searchBy: $searchBy
        search: $search
        rowFrom: $rowFrom
        rowTo: $rowTo
      ) @include(if: $searchPersons) @skip(if: $searchCompanies) {
        clientId
        clientName
        birthDate
        phone
        email
        passportDoc
        passportSer
        passportNum
        passportDate
        passportPlace
        passportCode
        address
        passWord
        phone2
        phone3
        address2
        blockComment
      }
      companies(companyName: $search)
        @include(if: $searchCompanies)
        @skip(if: $searchPersons) {
        companyId
        companyName
        companyFullName
        inn
        currentRow
        totalRows
      }
    }
  `,
  config: {
    skip: (ownProps) => ownProps.skip,
    options: ({ searchType, searchBy, search }) => {
      let searchValue = search;
      if (searchBy === "PASSPORT") {
        searchValue = searchValue.replace(/\D/g, "");
      }
      return {
        variables: {
          searchPersons: searchType === "PERSON",
          searchCompanies: searchType === "COMPANY",
          searchBy,
          search: searchValue,
        },
      };
    },
  },
  propTypes: {
    searchType: PropTypes.oneOf(["PERSON", "COMPANY"]).isRequired,
    searchBy: PropTypes.oneOf(["PHONE", "FIO", "PASSPORT"]).isRequired,
    search: PropTypes.string.isRequired,
    page: PropTypes.number,
  },
};



// WEBPACK FOOTER //
// ./src/model/gql/queries/searchClients.js